// extracted by mini-css-extract-plugin
export default {"list":"list__+f++D","list-item":"list-item__ZVk-b","align-center":"align-center__vHaTV","align-baseline":"align-baseline__PEc3R"};